// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trialVersion {
  position: fixed;
  z-index: 14;
  background: #c98d3d;
  color: #ffffff;
  top: 50%;
  transform: rotate(-90deg);
  padding: 5px 17px 5px 18px;
  margin: 0px;
  left: -42px !important;
  border-radius: 0px 0px 10px 10px;
  transition: all 0.5s ease-in-out 0s;
}

.trialVersion:hover {
  background: #fbae1f;
  color: #ffffff;
}

.loading {
  font-size: 20px;
  font-weight: 600;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,QAAA;EACA,yBAAA;EACA,0BAAA;EACA,WAAA;EACA,sBAAA;EACA,gCAAA;EAIA,mCAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;AACJ;;AACA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;AAEJ","sourcesContent":[".trialVersion {\r\n    position: fixed;\r\n    z-index: 14;\r\n    background: #c98d3d;\r\n    color: #ffffff;\r\n    top: 50%;\r\n    transform: rotate(-90deg);\r\n    padding: 5px 17px 5px 18px;\r\n    margin: 0px;\r\n    left: -42px !important;\r\n    border-radius: 0px 0px 10px 10px;\r\n    -moz-transition: all 0.5s ease-in-out 0s;\r\n    -o-transition: all 0.5s ease-in-out 0s;\r\n    -webkit-transition: all 0.5s ease-in-out 0s;\r\n    transition: all 0.5s ease-in-out 0s;\r\n}\r\n\r\n.trialVersion:hover {\r\n    background: #fbae1f;\r\n    color: #ffffff;\r\n}\r\n.loading{\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: white;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
